<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import i18n from "../../../i18n";
import Button from "@/components/button";
import { saleService } from "../../../services/saleservice/sale.service";
import popup from "@/components/c-popup";
import Input from "@/components/c-input";

import { paymentService } from "../../../services/paymentservice/payment.service";
/* eslint-disable no-console */
export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Button, popup, Input },
  data() {
    return {
      title: "Payment Detail",
      items: [
        {
          text: "Schedule",
          href: "/",
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      saledetail: null,
      saleschedule: null,
      registerDates: [],
      loan: null,
      loanDuration: 0,
      sale_id: 0,
      notation: '',
      schedule_id: 0,
      payment_id: 0
    };
  },
  mounted() {
    // this.loadingData(this.$route.params.id);

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
    }
  },
  methods: {
    
    loadingData: function(id) {
      this.sale_id = id;
      this.fetchingStats = false;
      saleService.saledetail(id)
        .then(response => {
          this.saledetail = response.data;
          this.registerDates = this.saledetail.register_date_show.split('-');
          // console.log(JSON.stringify(this.saledetail));
        });

      saleService.saleschedule(id)
        .then(response => {
          this.saleschedule = response.data;
          // console.log("AAAAAAA", JSON.stringify(this.saleschedule));

          this.loan = this.saleschedule.find(item => { return item.interest > 0 });
          let index = this.saleschedule.findIndex(item => item.interest > 0);

          this.loanDuration = this.saleschedule.length - index;
          // console.log(index, this.saleschedule.length);
          // this.registerDates = loan.pay_date_show.split('-');
          // console.log(JSON.stringify(loan));
        });
      

    },

    loadingPropertyById: function(id) {
      this.fetchingStats = false;

      saleService.getOneByProperty(id).then(response => {
        if(response.data != null) {
          saleService.saledetail(response.data.id)
            .then(response => {
              this.saledetail = response.data;
              this.registerDates = this.saledetail.register_date_show.split('-');
              // console.log(JSON.stringify(this.saledetail));
            });

          saleService.saleschedule(response.data.id)
            .then(response => {
              this.saleschedule = response.data;

              this.loan = this.saleschedule.find(item => { return item.interest > 0 });
              let index = this.saleschedule.findIndex(item => item.interest > 0);

              this.loanDuration = this.saleschedule.length - index;
              // this.registerDates = loan.pay_date_show.split('-');
            });
        }
      });
    },

    formatCurrency(value, sign = '$') {

      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;

    },

    getDay(date) {
      const weekday = ["អាទិត្យ", "ច័ន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"];
      let d = new Date(date);
      
      return weekday[d.getDay()];
      // console.log(date);
      // return '';
    },

    go_pay(){
      this.$router.push({ name: 'payment', params: { id: this.sale_id } });
    },

    add_notation(id, notation){
      this.notation = notation;
      this.schedule_id = id;
      this.$refs['generate-schedule'].show();
    },
    delete_payment(id){

      this.$swal.fire({
          title: i18n.t('general.confirm.title'),
          text: i18n.t('general.confirm.message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.confirm.yes'),
          cancelButtonText: i18n.t('general.confirm.no')
        }).then(result => {
          if (result.value) {

            this.payment_id = id;
            paymentService.remove(this.payment_id)
            .then(response => {
              console.log(response);
              //this.saledetail = response.data;
              let hasId = 'id' in this.$route.params;
              if(hasId) {
                this.loadingData(this.$route.params.id);     
              } else if('propertyid' in this.$route.query) {
                this.loadingPropertyById(this.$route.query.propertyid);
              }
            });

          }
        });

      
    },

    submitSave(){
      var push_data = {
        id: this.schedule_id,
        notation: this.notation
      };
      saleService.notation(push_data)
      .then(response => {
        document.getElementById('l_' + this.schedule_id).innerHTML = response.data;
        this.notation = '';
        this.schedule_id = 0;
      });
      this.$refs['generate-schedule'].hide();
    }
  },
};

</script>

<template>
  <Layout>
        
      <div class="col dblack">
      <center>
        <table width="100%" class="content-general"><tr><td class="center">
          <p class="h5 khm">កាលវិភាគបង់ប្រាក់</p>
          <p class="h5 enb">PAYMENT SCHEDULE</p>
          <p class="">
            <img src="@/assets/images/bellow01.png" style="width: 130px;"/>
          </p>
        </td></tr>
        </table>
      </center>
        <div class="row">
          <div class="col-sm-10"></div>
          <div class="col-sm-2 print">
              <Button :icon="'bx bx-dollar-circle'" 
                :buttonType="'button'"
                @click="go_pay()"
                :titleLocate="'property.payment'" />
          </div>
        </div>
        <br>
        <div style="height: 5px;"></div>
        <table style="width:100%">
          <tr><td colspan="2"><div class="hr-2"></div></td></tr>
        </table>
        <div style="height: 5px;"></div>
        <table class="content-general h6 schedule-table" width="100%">
          
            <tr class="thead">
              <td><p class="khs">ល.រ</p></td>
              <td colspan="2"><p class="khs">កាលបរិច្ឆេទបង់ប្រាក់</p></td>
              <td><p class="khs">ប្រាក់បង់ប្រចាំខែ</p></td>
              <td><p class="khs">ប្រាក់ដើម</p></td>
              <td><p class="khs">ការប្រាក់</p></td>
              <td><p class="khs">សមតុល្យប្រាក់ដើម</p></td>
              <td><p class="khs">ចំនួនថ្ងៃយឺត</p></td>
              <td><p class="khs">ទឹកប្រាក់ពីន័យ</p></td>
              <td><p class="khs">ទឹកប្រាក់សរុប</p></td>
              <td><p class="khs">ថ្ងៃបង់ជាក់ស្តែង</p></td>
              <!-- <td colspan="2"><p class="khs">ការបង់ប្រាក់</p></td> -->
              <td><p class="khs">ការបង់ប្រាក់</p></td>
              <td><p class="khs">មុខងារ</p></td>
            </tr>
          <tbody>
            <tr v-for="(list, index) in saleschedule" :key="list.id">
              <td><p class="khs">{{index+1}}</p></td>
              <td><p class="khs">{{`${list.pay_date_show}`}}</p></td>
              <td><p class="khs" >{{list.day_show}}</p></td>
              <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.integer_pay)}}</p></td>
              <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.principal_pay)}}</p></td>
              <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.interest)}}</p></td>
              <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.balance)}}</p></td>
              <td><p class="khs" style="text-align: right; padding-right: 10px">{{list.over_day}}</p></td>
              <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.penalty)}}</p></td>
              <td><p class="khs" style="text-align: right; padding-right: 10px">{{formatCurrency(list.total_pay)}}</p></td>
              <td>
                <p class="khs" style="text-align: center;" v-for="date_list in list.pay_list" :key="date_list.id">
                  <router-link   :target="'_blank'" v-if="date_list.is_auto==0"
                    :to="{ name: 'receipt', params: { id: date_list.id }}">
                    {{`${date_list.pay_date} (${formatCurrency(date_list.paid)})`}}
                  </router-link>
                  <span v-else>{{`${date_list.pay_date} (${formatCurrency(date_list.paid)})`}}</span>
                  <i @click="delete_payment(date_list.id)" v-if="date_list.over_day < 4" class="bx bx-trash" style="color: red; font-size: 1.5em; margin-top: 5px; cursor: pointer;"></i>
                </p>
              </td>
              <td v-if="list.schedule_status_id == 3" style="text-align:center; font-size: 17pt; line-height: 40%; color: #656569;"><span>&#x2611;</span></td>
              <td v-else style="text-align:center; font-size: 25pt; line-height: 40%; color: #656569;"><span>&squ;</span></td>

              <!-- <td v-if="list.schedule_status_id == 1"><p class="khs" style="text-align: right; padding-right: 10px; color:white; background-color:darkblue;">មិនទាន់ទូទាត់</p></td>
              <td v-else-if="list.schedule_status_id == 2"><p class="khs" style="text-align: right; padding-right: 10px; color:white; background-color:darkorange;">បានទូទាត់ខ្លះ</p></td>
              <td v-else><p class="khs" style="text-align: right; padding-right: 10px; color:white; background-color:darkgreen;">បានទូទាត់រួច</p></td> -->
              <td>
                <label for="notation" :id="'l_' + list.id">{{list.notation}}</label>
                <i @click="add_notation(list.id, list.notation)" class="bx bx-edit" style="color: blue; font-size: 1.5em; margin-top: 5px; cursor: pointer;"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <popup id="generate-schedule" ref="generate-schedule" :full_title="$t('general.add-notation')">
        <div class="row">
          <div class="col-md-12">
                <Input 
                  :type="'text'"
                  :id="'id_notation'"
                  :disabled="false"
                  v-model="notation"
                  :label="'general.notation'"  />
            </div>
        </div>
          <div class="row">
            <div class="col-10"></div>
            <div class="col-2">
              <Button v-bind:icon="'bx bx-save bx-tada'" 
                v-bind:buttonType="'button'"
                @click="submitSave()"
                v-bind:requesting="tryingToSubmit"
                v-bind:title="$t('general.save')"  />  
            </div>
          </div>
          
      </popup>
      <popup id="payment-history" ref="payment-history" :full_title="$t('general.payment-history')">
        <div class="row">
          
        </div>
      </popup>
  </Layout>
</template>